// src/store/enrollUi.ts
import Vue from 'vue';

interface EnrollUi {
    imageSrc: string;
    key: number;
    open(img: string): void;
}

export const enrollUi = Vue.observable<EnrollUi>({
    imageSrc: '',
    key: 0,
    open(img: string) {
        this.imageSrc = img;
        this.key++; // force remount of the dialog
    },
});